import { systemEngineEnvironment } from "services/environment/systemEngine";

import { EMPTY_NETWORK_POLICY, ServiceAccount } from "./types";

export const getServiceAccountCreateStatement = (serviceAccount: {
  name: string;
  description: string;
  networkPolicyName?: string;
  isOrganizationAdmin: boolean;
}) => {
  const { name, description, networkPolicyName, isOrganizationAdmin } =
    serviceAccount;
  const descriptionSql = description
    ? systemEngineEnvironment.formatter.formatQuery(`\nDESCRIPTION = ?`, [
        description,
      ])
    : "";

  const networkPolicySql =
    networkPolicyName === EMPTY_NETWORK_POLICY || !networkPolicyName
      ? ""
      : `\nNETWORK_POLICY = "${networkPolicyName}"`;

  const isOrganizationAdminSql = isOrganizationAdmin
    ? systemEngineEnvironment.formatter.formatQuery(
        `\nIS_ORGANIZATION_ADMIN = ?`,
        [isOrganizationAdmin]
      )
    : "";

  const withSql =
    descriptionSql || networkPolicySql || isOrganizationAdminSql
      ? ` WITH${descriptionSql}${networkPolicySql}${isOrganizationAdminSql}`
      : "";

  const sql = `CREATE SERVICE ACCOUNT "${name}"${withSql};`;
  return sql;
};

export const createServiceAccount = async (
  fields: {
    name: string;
    description: string;
    networkPolicyName?: string;
    isOrganizationAdmin: boolean;
  },
  accountName?: string
) => {
  const sql = getServiceAccountCreateStatement(fields);
  const result = await systemEngineEnvironment.execute<ServiceAccount>(sql, {
    accountName,
  });

  const [response] = result;
  return response.rows;
};
